import { IconChevronRight12 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { useIsFiltersRedesign } from '../../../context';

interface IChipProps {
  children?: React.ReactNode;
  hasChevron?: boolean;
  asButton?: boolean;
  /**
   * В фильтре выбрано значение. В редизайне такой чипс подсвечивается как активный,
   * в текущем дизайне ни на что не влияет.
   */
  isSelected?: boolean;
  testId?: string;
  onClick?(): void;
}

export const Chip = ({
  children,
  hasChevron = true,
  onClick,
  asButton = true,
  isSelected = false,
  testId,
}: IChipProps) => {
  const isRedesign = useIsFiltersRedesign();

  const className = cn(
    styles['chip'],
    !asButton && styles['chip_button'],
    isRedesign && styles['chip_redesign'],
    isRedesign && isSelected && styles['chip_redesign_selected'],
  );

  const chevron = hasChevron && (
    <span className={cn(styles['icon'], isRedesign && styles['icon_redesign'])}>
      {isRedesign ? (
        <IconActionChevronDownSmall16 color="icon-main-default" />
      ) : (
        <IconChevronRight12 color="primary_100" />
      )}
    </span>
  );

  if (asButton) {
    return (
      <button className={className} onClick={onClick} data-testid={testId}>
        {children}
        {chevron}
      </button>
    );
  }

  return (
    <div className={className} onClick={onClick} data-testid={testId}>
      {children}
      {chevron}
    </div>
  );
};
